<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :headers="headers"
            :items="tableItems"
            class="elevation-1"
            dense
            :loading="settlementsLoadStatus===1"
            hide-default-footer
            :search="search"
            must-sort
            disable-pagination
            @current-items="getFiltered"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Raport windykacyjny</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Rok" v-model="selectedYear" clearable class="choose_year" :items="calendarYears" hide-details ></v-select>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Miesiąc" v-model="selectedMonth" clearable class="choose_month" :items="lookups.months" hide-details ></v-select>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>

                <v-spacer></v-spacer>
                <!-- drukowanie i excel -->
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      size="28"
                      class="mr-2"
                      :disabled="filteredItems.length==0"
                      @click="printFile"
                    >
                      mdi-printer
                    </v-icon>
                  </template>
                  <span>Drukuj</span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      size="28"
                      class="mr-2"
                      :disabled="filteredItems.length==0"
                      @click="downloadFilePDF"
                    >
                      mdi-file-pdf
                    </v-icon>
                  </template>
                  <span>Pobierz jako PDF</span>
                </v-tooltip>

                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      size="28"
                      class="mr-2"
                      :disabled="filteredItems.length==0"
                      @click="downloadFile"
                    >
                      mdi-file-excel
                    </v-icon>
                  </template>
                  <span>Pobierz jako Excel</span>
                </v-tooltip>
                
              </v-toolbar>
            </template>

            
            <template  v-slot:item.amount="{ item }">
              <template>{{ $n(item.amount-item.posted, 'currency', 'pl-PL') }}</template>
            </template>

            <template v-if="tableItems.length>0" slot="body.append">
                  <tr class="v-data-table__selected font-weight-medium subheading">
                        <td></td><td></td><td></td><td></td><td></td><td></td>
                        <td>Suma</td>
                        <td>{{$n(sumField('amount')-sumField('posted'), 'currency', 'pl-PL')}}</td>
                  </tr>
            </template>
          </v-data-table> 
          </v-card>
      </v-col>
</template>

<script>
  import Vue from 'vue'
  import XLSX from "xlsx"
  import {jsPDF} from 'jspdf'
  import logusLogo from '../plugins/jspdf_resources'
  import 'jspdf-autotable'
  import i18n from "../main";
  
  export default {
    components:{
      confirm
    },
    data: () => ({
      search:'',
      filteredItems:[],
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp'},
        { text: 'Nazwisko', value: 'child.surname' },
        { text: 'Imię', value: 'child.name'},
        { text: 'Miesiąc', value: 'month'},
        { text: 'Rok', value: 'year'},
        { text: 'Cennik', value: 'rates'},
        { text: 'Grupa', value: 'courses'},
        { text: 'Kwota', value: 'amount'},
      ],
    }),
    watch: {
    
    },
    computed: {
      calendarYears(){
        var calYears = [];
        this.lookups.years.forEach(year => {
          if(!Vue._.find(calYears,{value:year.year_from}))calYears.push({value:year.year_from,text:year.year_from.toString()});
          if(!Vue._.find(calYears,{value:year.year_to}))calYears.push({value:year.year_to,text:year.year_to.toString()});
        });
        return calYears;
      },
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getSettlementOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setUnpayedSettlementOptions', {options:value} )
        }
      },
      selectedYear:{
        get () {
          return this.$store.getters.getSettlementOptions.selectedYear;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedYear = value;
          currentOptions.selectedCourse = 0;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedYear} );
        }
      },

      selectedMonth:{
        get () {
          return this.$store.getters.getSettlementOptions.selectedMonth;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedMonth = value;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedCourse} );
        }
      },
    
      tableItems(){
        return this.$store.getters.getSettlements;
      },
      settlementsLoadStatus(){
        return this.$store.getters.getSettlementsLoadStatus;
      },
    },
    mounted(){

      if(this.lookups.years.length>0){
        this.loadSettlements();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadSettlements();
        }, 2000)
      }
    },
    methods: {
      loadSettlements(){
        this.search='';
        var currentOptions = {...this.$store.getters.getSettlementOptions};
        currentOptions.selectedYear = undefined;
        currentOptions.selectedMonth = undefined;
        this.$store.dispatch( 'setUnpayedSettlementOptions', {options:currentOptions} )
      },
      sumField(key) {
        return this.filteredItems.reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0);
      },
      getFiltered(items){
        this.filteredItems = items;
      },
      downloadFile(){
        //przygotowanie danych
        var items = []
        this.filteredItems.sort((a,b)=>(a.lp>b.lp)?1:(b.lp>a.lp)?-1:0).forEach(item => {
          items.push({surname:item.child.surname, name:item.child.name, month:item.month, 
          year:item.year, rates:item.rates, courses:item.courses, amount:item.amount-item.posted})
        });

        var wb = XLSX.utils.book_new()
        var ws_name = "Raport";
        var ws = XLSX.utils.aoa_to_sheet([["Nazwisko","Imię","Miesiąc","Rok","Cennik","Grupa","Kwota"]]);
        XLSX.utils.sheet_add_json(ws,items,{header:["surname","name","month","year","rates","courses","amount"], skipHeader:true, origin:1})
        
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
      
        var rightNow = new Date();
        rightNow.setMinutes(rightNow.getMinutes() - rightNow.getTimezoneOffset());
        var filename = 'Raport_' + rightNow.toISOString().replace(/-/g,'').replace(/:/g,'').replace('T','_').slice(0,15) +'.xlsx';
        XLSX.writeFile(wb, filename, {})

      },
      generatePDF(){
        var rightNow = new Date();
        var items = []
        var lp = 1;
        var page = 1;
        this.filteredItems.sort((a,b)=>(a.lp>b.lp)?1:(b.lp>a.lp)?-1:0).forEach(item => {
          items.push([lp++,item.child.surname, item.child.name, item.month, 
          item.year,item.rates, item.courses, i18n.n(item.amount-item.posted, 'currency', 'pl-PL')]);
        });

        var doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        })
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

        doc.setFont("Roboto-Medium", "bold"); // set font
        doc.setFontSize(14);
        doc.addImage(logusLogo, 'PNG', 5, 5, 22.5, 20);
        doc.text('Raport windykacyjny', pageWidth / 2, 18, {align:'center',baseline:'bottom'});
        doc.setFont("Roboto-Regular", "normal"); // set font
        doc.setFontSize(10);
        doc.autoTable({
          didDrawPage: (data) => {
            doc.text(page.toString(), 5, pageHeight-5);
            doc.text(this.user.name+' '+this.user.surname+' / '+rightNow.toLocaleString('pl'), pageWidth-5, pageHeight-5, {align:'right'});
            page++;
          },
          theme:'grid',
          styles:{font:'Roboto-Regular', fontSize:9 },
          headStyles: { fillColor: [210, 210, 210],textColor:20 },
          footStyles: { fillColor: [210, 210, 210],textColor:20 },
          startY: 30,
          showFoot:'lastPage',
          margin: {top:5,bottom:10,left:5,right:5},
          columnStyles: { 7: {font:'Roboto-Medium',fontStyle:'bold', halign: 'right' } },
          head: [Vue._.map(this.headers,'text')],
          body: items,
          foot: [
            [
              { content: 'Suma', colSpan: 7, styles: {font:'Roboto-Medium',fontStyle:'bold', halign: 'right' } },
              { content:i18n.n(this.sumField('amount')-this.sumField('posted'), 'currency', 'pl-PL'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'right' }}],
          ],
        })
        
        return doc;
      },
      downloadFilePDF(){
        var rightNow = new Date();
        var doc = this.generatePDF();
        var filename = 'Raport_' + rightNow.toISOString().replace(/-/g,'').replace(/:/g,'').replace('T','_').slice(0,15) +'.pdf';
        doc.save(filename);
      },
      printFile(){
        var doc = this.generatePDF();
        doc.autoPrint();
        doc.output('dataurlnewwindow');
      }
    },
  }
</script>


<style scoped>
span.rateerror{
  color:red;
}
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 100px;
}

.choose_month{
      max-width: 150px;
}
</style>